import { attributes, define } from "@type-r/models";
import { globalStore } from "api";
import { Loading } from "lqx-react/src";
import React from "react";
import { PendingActionsInvoices } from "../../api";
import { OpenItems } from "../../common/open-items";

@define
export class OverdueState extends attributes({
    overdueInvoicesWithPPD: [PendingActionsInvoices],
    overdueInvoicesWithoutPPD: [PendingActionsInvoices],
    overdueInvoicesWithPPDCount: Number,
    overdueInvoicesWithoutPPDCount: Number,
    isReady: Boolean
}) {
    async fetch() {
        const overdueInvoices = await PendingActionsInvoices.fetchOverdueInvoices();

        this.overdueInvoicesWithPPD.set(overdueInvoices.invoicesWithPromiseToPayDate);
        this.overdueInvoicesWithoutPPD.set(overdueInvoices.invoicesWithoutPromiseToPayDate);

        this.overdueInvoicesWithPPD.updateEach(element => {
            let customer = globalStore.getRelationshipById(element.relationshipId).Customer;
            element.customerName = customer.companyName;
            element.customerExternalId = customer.externalRelationshipId;
        });

        this.overdueInvoicesWithoutPPD.updateEach(element => {
            let customer = globalStore.getRelationshipById(element.relationshipId).Customer;
            element.customerName = customer.companyName;
            element.customerExternalId = customer.externalRelationshipId;
        });

        this.overdueInvoicesWithPPDCount = this.overdueInvoicesWithPPD.reduce((curr: number, sum) => curr + (sum ? sum.count : 0), 0);
        this.overdueInvoicesWithoutPPDCount = this.overdueInvoicesWithoutPPD.reduce((curr: number, sum) => curr + (sum ? sum.count : 0), 0);

        return this;
    }

    getCount() {
        return this.overdueInvoicesWithPPDCount + this.overdueInvoicesWithoutPPDCount;
    }
}

export const OverdueInvoices = ({ state }: { state: OverdueState }) => {

    return (
        state.isReady ? <>
            <OpenItems
                title={`Open Items with Promise To Pay Date (${state.overdueInvoicesWithPPDCount})`}
                invoices={state.overdueInvoicesWithPPD as any}
                linkUrl='/invoices/statement'
                bucket='overdue'
                hasPromiseToPayOverdue={true} />

            <OpenItems
                title={`Open Items without Promise To Pay Date (${state.overdueInvoicesWithoutPPDCount})`}
                invoices={state.overdueInvoicesWithoutPPD as any}
                linkUrl='/invoices/statement'
                bucket='overdue'
                hasPromiseToPayOverdue={false} />
        </> : <Loading />
    );
}
